import { Effect, Layer, Result } from "effect";
import { ChatFileIo } from "./composer-service.ts";
export const ChatFileIoLive = Layer.succeed(ChatFileIo, ChatFileIo.of({
  prefix: file => Effect.tryPromise({ try: () => file.slice(0, 4_096).arrayBuffer(), catch: () => null }).pipe(
    Effect.map(buffer => new Uint8Array(buffer)), Effect.catch(() => Effect.succeed(null))),
  dataUrl: (file, mime) => Effect.acquireUseRelease(Effect.sync(() => new FileReader()), reader => Effect.callback<string>(resume => {
    const error = () => resume(Effect.succeed(""));
    const load = () => resume(Effect.sync(() => {
      const value = typeof reader.result === "string" ? reader.result : "", comma = value.indexOf(",");
      return comma === -1 ? "" : `data:${mime};base64,${value.slice(comma + 1)}`;
    }));
    reader.addEventListener("error", error); reader.addEventListener("load", load);
    const started = Result.try(() => reader.readAsDataURL(file));
    if (Result.isFailure(started)) resume(Effect.succeed(""));
    return Effect.sync(() => { reader.removeEventListener("error", error); reader.removeEventListener("load", load); });
  }).pipe(Effect.catchCause(() => Effect.succeed(""))), reader => Effect.sync(() => {
    if (reader.readyState === FileReader.LOADING) reader.abort();
  })),
  identity: length => Effect.sync(() => globalThis.crypto?.randomUUID?.() ?? `attachment-${Date.now()}-${length}`)
}));
